import React from "react";

export const IconLightning = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
    </svg>
);

export const IconPuzzle = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M21 13v7h-7a3 3 0 10-6 0H1v-7a3 3 0 100-6V1h7a3 3 0 106 0h7v7a3 3 0 100 6z" />
    </svg>
);

export const IconRocket = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M12 2c3 0 7 2 10 5-2 1-5 2-7 4l-3 3c-2 2-3 5-4 7-3-3-5-7-5-10C3 6 7 2 12 2z" />
        <circle cx="15" cy="9" r="2" fill="white" />
    </svg>
);

export const IconTools = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M14 3l7 7-3 3-7-7 3-3zM2 15l7 7 9-9-7-7-9 9z" />
    </svg>
);